export const iconOption = ({ rtpData, max, min }) => {
  return {
    grid: {
      left: "4%",
      right: "4%",
      bottom: "10%",
      top: "10%",
      containLabel: true,
      borderWidth: "0",
    },
    xAxis: {
      type: "category",
      show: false,
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      max: (max > min ? max : min) + 10,
      min: -((max > min ? max : min) + 10),
      show: false,
      axisLabel: {
        show: false,
      },
    },
    series: [
      {
        symbolSize: 3.5,
        symbol: "circle",
        data: rtpData,
        type: "line",
        lineStyle: {
          normal: {
            width: 1.5,
          },
        },
        itemStyle: {
          normal: {
            color: `#55b0ee`,
            lineStyle: {
              color: `#55b0ee`,
            },
          },
        },
      },
    ],
  }
}
export const option = ({ rtpData, xAxisData, max, min }) => {
  return {
    xAxis: {
      type: "category",
      data: xAxisData,
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      axisTick: {
        show: false,
      },
      max: (max > min ? max : min) + 10,
      min: -((max > min ? max : min) + 10),
      type: "value",
      data: rtpData,
      axisLine: { show: false },
      axisLabel: {
        fontWeigh: "bold",
      },
    },
    textStyle: {
      fontSize: 16,
    },
    series: [
      {
        symbol: "circle",
        animation: false,
        symbolSize: 10,
        data: rtpData,
        type: "line",
        label: {
          normal: {
            show: true,
            position: "top",
          },
        },
        lineStyle: {
          normal: {
            width: 3,
            shadowBlur: 1,
            shadowOffsetY: 1,
          },
        },
        itemStyle: {
          normal: {
            color: `#55b0ee`,
            lineStyle: {
              color: `#55b0ee`,
            },
          },
        },
      },
    ],
  }
}
